import {Directive, HostListener, ElementRef, Input} from '@angular/core';

@Directive({
    selector: '[scrollOverlay]',
    standalone: false
})
export class scrollOverlayDirective { // for disabling mouse action inside input type number.
  private hasDecimalPoint = false;  
  private navigationKeys = [
        'Backspace',
        'Delete',
        'Tab',
        'Escape',
        'Enter',
        'Home',
        'End',
        'ArrowLeft',
        'ArrowRight',
        'Clear',
        'Copy',
        'Paste',
        'dot',
      ]; 
    @Input() pattern: any;
    @Input() fieldType: any;
    regex: RegExp;
    inputElement: HTMLInputElement;

    constructor(private _el: ElementRef) {
      this.inputElement = _el.nativeElement;
    }
    
    @HostListener('keydown', ['$event'])
    onKeyDown(e: KeyboardEvent) {
      this.hasDecimalPoint = this.inputElement.value.indexOf('.') > -1
      console.log("this.inputElement.value ",this.hasDecimalPoint);
      this.regex = this.pattern ? RegExp(this.pattern) : null;
      if (
        // Allow: Delete, Backspace, Tab, Escape, Enter, etc
        this.navigationKeys.indexOf(e.key) > -1 || 
        (e.key === 'a' && e.ctrlKey === true) || // Allow: Ctrl+A
        (e.key === 'c' && e.ctrlKey === true) || // Allow: Ctrl+C
        (e.key === 'v' && e.ctrlKey === true) || // Allow: Ctrl+V
        (e.key === 'x' && e.ctrlKey === true) || // Allow: Ctrl+X
        (e.key === 'a' && e.metaKey === true) || // Cmd+A (Mac)
        (e.key === 'c' && e.metaKey === true) || // Cmd+C (Mac)
        (e.key === 'v' && e.metaKey === true) || // Cmd+V (Mac)
        (e.key === 'x' && e.metaKey === true) || // Cmd+X (Mac)
        (e.key === '.' && (this.fieldType.toLowerCase() =='double' || this.fieldType.toLowerCase() == 'float') && !this.hasDecimalPoint) //allowing one decimal point
      ) {
        return;  // let it happen, don't do anything
      }
      // Ensure that it is a number and stop the keypress
      if (e.key === ' ' || isNaN(Number(e.key))) {
        e.preventDefault();
      }
      //commented because it was causing bug (code copied for input type text and implement on number)
      // if (this.regex) {
      //   const newValue = this.forecastValue(e.key);
      //   if (!this.regex.test(newValue)) {
      //     e.preventDefault();
      //   }
      // }

    }
    private forecastValue(key: string): string {
      const selectionStart = this.inputElement.selectionStart;
      const selectionEnd = this.inputElement.selectionEnd;
      const oldValue = this.inputElement.value;
      const selection = oldValue.substring(selectionStart, selectionEnd);
      return selection
        ? oldValue.replace(selection, key)
        : oldValue.substring(0, selectionStart) +
            key +
            oldValue.substring(selectionStart);
    }

    @HostListener('mousewheel', ['$event']) onMouseWheelChrome(event: any) {
        this.disableScroll(event);
    }
    
    @HostListener('DOMMouseScroll', ['$event']) onMouseWheelFirefox(event: any) {
        this.disableScroll(event);
    }
    
    @HostListener('onmousewheel', ['$event']) onMouseWheelIE(event: any) {
        this.disableScroll(event);
    }
    
    
    disableScroll(event: any) {
        if (event.srcElement.type === "number")
            event.preventDefault();
    }
  
}
